import { BasicButton, BasicInput, ModalComponent } from "Common/Components";
import { useModalDepartament } from "../../hooks";

export const ModalDepartament = () => {
  const { isEdit, isOpenModal, clearAll, formik, setIsOpenModal, t } =
    useModalDepartament();

  return (
    <ModalComponent
      modalTitle={
        isEdit ? t("departament.TitleEdit") : t("departament.TitleCreate")
      }
      show={isOpenModal}
      onHide={() => {
        setIsOpenModal(false);
        clearAll();
        formik.resetForm();
      }}
      size="md"
    >
      <form
        className="mt-3"
        id="signInForm"
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
          return false;
        }}
      >
        <BasicInput
          label={t("departament.form.labels.description")}
          placeholder={t("departament.form.placeholders.description")}
          id="description"
          name="description"
          type="text"
          value={formik.values.description}
          isError={!!(formik.touched.description && formik.errors.description)}
          errorMessage={formik.errors.description || ""}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <div className="col-span-12 mt-3">
          <div className="flex justify-end">
            <BasicButton
              type="submit"
              onClick={() => {}}
              disabled={formik.isSubmitting}
            >
              <span className="text-white">
                {isEdit
                  ? t("departament.buttons.edit")
                  : t("departament.buttons.addbtn")}
              </span>
            </BasicButton>
          </div>
        </div>
      </form>
    </ModalComponent>
  );
};
